import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid bg-white m-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" })
], -1)
const _hoisted_2 = { class: "row mt-4" }
const _hoisted_3 = {
  class: "col-12 col-lg-3",
  "data-aos": "fade-right",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_4 = {
  class: "col-12 col-lg-9 align-items-center center-highlight-item bg-white p-4 rounded",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_5 = {
  key: 0,
  class: "text-start text-primary px-3"
}
const _hoisted_6 = {
  key: 1,
  class: "text-start text-primary px-3"
}
const _hoisted_7 = {
  key: 2,
  class: "text-start text-primary"
}
const _hoisted_8 = { class: "container w-50 mt-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col p-5" }
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = {
  key: 2,
  class: "text-center"
}
const _hoisted_14 = { class: "badge badge-primary bg-secondary ms-1 mb-2 fs-6" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-facebook fs-3" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-line fs-3" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2" }, null, -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-whatsapp fs-3" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryItem)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.doc.nameTH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.doc.nameCH), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.doc.nameEN), 1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "img-fluid w-75 rounded",
            src: _ctx.imageUrl(_ctx.doc.image),
            style: {"aspect-ratio":"1/1"}
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.store.state.language==='th')
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.doc.experienceTH), 1))
            : (_ctx.store.state.language==='ch')
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.doc.experienceCH), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.doc.experienceEN), 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doc.languages, (item) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item), 1))
          }), 256)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              target: "_blank",
              href: `${_ctx.doc.facebook}`
            }, _hoisted_18, 8, _hoisted_16),
            _hoisted_19,
            _createElementVNode("a", {
              target: "_blank",
              href: `${_ctx.doc.line}`
            }, _hoisted_22, 8, _hoisted_20),
            _hoisted_23,
            _createElementVNode("a", {
              target: "_blank",
              href: `${_ctx.doc.wechat}`
            }, _hoisted_26, 8, _hoisted_24)
          ])
        ])
      ])
    ])
  ], 64))
}